import { searchReducer } from '../slices/searchSlice';
import { resultReducer } from '../slices/resultSlice';

const reducer = {
    searchReducer,
    resultReducer,
    // other reducers
};

export default reducer;
